/* eslint @typescript-eslint/no-extra-semi: "off" */
import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import ApiGateway from 'theme/api/api-gateway'
import { useFirebaseService } from 'theme/services/firebase-service'
import { Remarkable } from 'remarkable'
// import { Link } from 'gatsby'
import { Transition, Menu } from '@headlessui/react'
import { SessionSpeakerCard } from './sessionSpeakers'
import { useAuthService } from 'theme/services/auth/auth-service'
import { getTalkTitle } from 'theme/utils/generic-helpers'
import withToggleFavouriteSession from 'theme/hoc/withToggleFavouriteSession'
import withFeedbackModal from 'theme/hoc/withFeedbackModal'
import { useTimezoneService } from 'theme/services/timezoneService'
import { getLocalDay, getLocalTime } from 'theme/utils/timezone-helpers'
import SessionItemRegister from 'theme/components/organisms/agenda/workshopRegisterButton'
import { isEqual } from 'lodash-es'
import { Rating } from 'react-simple-star-rating'
import { CheckCircleIcon } from '@heroicons/react/outline'
import { checkUserConferenceAccess, getConferenceTickets } from 'theme/utils/auth-helpers.tsx'
import { sessionTypes } from 'theme/utils/session-helpers'
import Tooltip from 'rc-tooltip'
import 'rc-tooltip/assets/bootstrap.css'
import { InformationCircleIcon } from '@heroicons/react/outline'

import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  RedditShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookIcon,
  LinkedinIcon,
  RedditIcon,
  TwitterIcon,
  WhatsappIcon,
} from 'react-share'
import InPersonActivityRegisterButton from 'theme/components/organisms/agenda/inPersonActivityRegisterButton'

const SessionDetails = ({
  session,
  conferenceId,
  toggleFavourite,
  userUsedPlaces,
  isRegistered,
  conferenceLocation,
  registrations,
  agendaDayTimezone,
}) => {
  const [showTranscript, setShowTranscript] = useState(true)
  const [isFavourite, setFavourite] = useState(null)
  const [userFeedback, setUserFeedback] = useState(null)
  const [loggedIn, setLoggedIn] = useState(false)
  const [hasTicket, setHasTicket] = useState(false)
  const [verified, setVerified] = useState(false)
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(false)

  const feedbackDbRead = useRef(false)
  const md = new Remarkable({ breaks: true })
  const authService = useAuthService()
  const user = authService.user
  const firebase = useFirebaseService()
  const url = typeof window !== 'undefined' ? window.location.href : ''
  const { tickets, workshopTickets } = getConferenceTickets(user, conferenceId)

  const isPublic =
    session &&
    session.data.Public_Release_Date &&
    new Date(session.data.Public_Release_Date).getTime() < Date.now()

  useEffect(() => {
    async function setData() {
      setLoggedIn(!!user)
      setHasTicket(checkUserConferenceAccess(user, conferenceId))
      setVerified(user && user.emailVerified)
    }
    setData()
  }, [user])

  // Notes
  const notesRef = useRef(null)
  const requiresRegister =
    session &&
    session.data.Session_Groups &&
    session.data.Session_Groups[0] &&
    session.data.Session_Groups[0].data.Requires_Register
  const sessionCapacity = session.data.Capacity ?? null

  const timezoneService = useTimezoneService()
  const description = md.render(session.data.Talk_Description)
  // get info for the feebback / register buttons
  const [sessionInfo, setSessionInfo] = useState({
    lastUpdateTime: new Date().getTime(),
    futureSession: new Date(session.data.UTC_Start_Time).getTime() > Date.now(),
    feedbackEnded: new Date(session.data.UTC_End_Time).getTime() < Date.now() + 1000 * 60 * 60 * 24,
    publicSession:
      session.data.Public_Release_Date && new Date(session.data.Public_Release_Date).getTime() < Date.now(),
  })
  const userRegistration =
    registrations.find((item) => item.sessionId === session.id && item.productId === conferenceId) ?? null
  const [isOpen, setIsOpen] = useState(false)
  const [speakerRating, setSpeakerRating] = useState(null)
  const [contentRating, setContentRating] = useState(null)
  const [feedbackComment, setFeedbackComment] = useState('')
  const isForum = session.data.Session_Groups?.[0]?.data?.Format === 'Forum' ?? null
  const isActivity = session.data.Session_Groups?.[0]?.data?.Format === 'Activity' ?? null
  const isWorkshop = session.data.Session_Groups?.[0]?.data?.Format === 'Workshop' ?? null

  // get the speaker cards

  const publishedSpeakers = session.data.Speakers?.filter((speaker) => {
    // Check if both speaker and speaker's Person data are present
    return speaker?.data?.Person && speaker.data.Person[0].data.Person_Status === 'Published'
  })
  const speakerCards =
    publishedSpeakers &&
    publishedSpeakers.map((speakerObj, idx) => {
      return <SessionSpeakerCard speakerObj={speakerObj} key={idx} />
    })

  // const handleInputChange = debounce(() => {
  //   saveNotes(notesRef.current.value)
  // }, 300)

  // const saveNotes = (note) => ApiGateway.saveSessionNote(firebase, user.uid, session.id, note)

  const parseLimitsData = () => {
    // console.log('alltickets', workshopTickets)
    const workshopTicket =
      workshopTickets &&
      workshopTickets.length &&
      workshopTickets.find((item) => item.productId === conferenceId)
    // console.log('workshopTIcket', workshopTicket)

    // const { sessionLimit = 2 } = workshopTicket

    return {
      userUsedPlaces,
      userSessionLimit: workshopTicket.sessionLimit,
    }
  }

  const fetchFeedback = () => {
    try {
      ApiGateway.getSessionFeedback(firebase, user.uid, session.id).then((userFeedbackDb) => {
        if (userFeedbackDb) {
          setUserFeedback(userFeedbackDb)
          if (userFeedbackDb.speakerRating) setSpeakerRating(userFeedbackDb.speakerRating)
          if (userFeedbackDb.contentRating) setContentRating(userFeedbackDb.contentRating)
          if (userFeedbackDb.feedbackComment) setFeedbackComment(userFeedbackDb.feedbackComment)
        }

        feedbackDbRead.current = true
      })
    } catch (e) {
      feedbackDbRead.current = true
      console.error(e)
    }
  }

  const speakerRatingChanged = (value) => {
    setSpeakerRating(value)
    setFeedbackSubmitted(true)
    if (userFeedback) {
      userFeedback.speakerRating = value
      setUserFeedback(userFeedback)
    } else setUserFeedback({ speakerRating: value })

    ApiGateway.setSessionFeedback(firebase, user.uid, session.id, {
      ...userFeedback,
      uid: user.uid,
      conference: conferenceId,
      sessionId: session.id,
      recordId: session.recordId,
      speakerRating: value,
    })
  }

  const contentRatingChanged = (value) => {
    setContentRating(value)
    setFeedbackSubmitted(true)
    if (userFeedback) {
      userFeedback.contentRating = value
      setUserFeedback(userFeedback)
    } else setUserFeedback({ contentRating: value })

    ApiGateway.setSessionFeedback(firebase, user.uid, session.id, {
      ...userFeedback,
      uid: user.uid,
      conference: conferenceId,
      sessionId: session.id,
      recordId: session.recordId,
      contentRating: value,
    })
  }
  const feedbackCommentChanged = (event) => {
    const value = event.target.value
    setFeedbackComment(value)
    setFeedbackSubmitted(true)
    if (userFeedback) {
      userFeedback.feedbackComment = value
      setUserFeedback(userFeedback)
    } else setUserFeedback({ feedbackComment: value })

    ApiGateway.setSessionFeedback(firebase, user.uid, session.id, {
      ...userFeedback,
      uid: user.uid,
      conference: conferenceId,
      sessionId: session.id,
      recordId: session.recordId,
      feedbackComment: value,
    })
  }

  useEffect(() => {
    if (!user) {
      return
    }

    fetchFeedback()
  }, [user])

  useEffect(() => {
    if (!user) {
      return
    }

    ;(async () => {
      const [noteDBData, isFavouriteDBData] = await Promise.all([
        ApiGateway.getSessionNote(firebase, user.uid, session.id),
        ApiGateway.getFavouriteSession(firebase, user.uid, session.id),
      ])

      if (notesRef && notesRef.current) notesRef.current.value = noteDBData
      setFavourite(isFavouriteDBData)
    })()
  }, [user])

  useEffect(() => {
    const timer = setInterval(() => {
      const tempFutureSession = new Date(session.data.UTC_Start_Time).getTime() > Date.now()
      const tempFeedbackEnded =
        new Date(session.data.UTC_End_Time).getTime() < Date.now() + 1000 * 60 * 60 * 24
      const tempPublicSession = new Date(session.data.Public_Release_Date).getTime() < Date.now()
      if (
        !isEqual(sessionInfo.futureSession, tempFutureSession) ||
        !isEqual(sessionInfo.feedbackEnded, tempFeedbackEnded) ||
        !isEqual(sessionInfo.publicSession, tempPublicSession)
      ) {
        setSessionInfo({
          lastUpdateTime: new Date().getTime(),
          futureSession: tempFutureSession,
          feedbackEnded: tempFeedbackEnded,
          publicSession: tempPublicSession,
        })
      }
      setIsOpen(true)
    }, 1000 * 60)
    return () => clearInterval(timer)
  }, [sessionInfo])

  const getDetails = () => {
    return {
      // Whatever we will need in email
      name: session.data.Talk_Title,
      startTime: session.data.UTC_Start_Time,
      timezone: timezoneService.timezone,
    }
  }

  const speakerNames =
    session.data.Speakers &&
    session.data.Speakers.map((speaker) => {
      return speaker?.data?.Person && speaker.data.Person[0].data.Person_First.trim()
    })
  let speakerString = speakerNames && speakerNames[0]
  if (speakerNames && speakerNames.length > 1)
    speakerString = speakerNames.slice(0, -1).join(',') + ' and ' + speakerNames.slice(-1)
  if (!speakerString) speakerString = ''

  const hasSessionType = sessionTypes.find((type) => type.name === session.data.Session_Groups[0].data.Format)

  return (
    <>
      {/* {!sessionInfo.futureSession &&
        (tickets.length > 0 || sessionInfo.publicSession) &&
        (!requiresRegister || (requiresRegister && isRegistered)) &&
        user && (
          <Transition
            show={isOpen}
            enter="transition duration-200 ease-out"
            enterFrom="transform scale-95 opacity-0"
            enterTo="transform scale-100 opacity-100"
            leave="transition duration-75 ease-out"
            leaveFrom="transform scale-100 opacity-100"
            leaveTo="transform scale-95 opacity-0"
            className="bg-slate-50 p-8 border border-gray-200"
          >
            <h2 className="text-xl pt-4">Share your feedback with {speakerString}</h2>
            <p className="text-gray-500 text-md">Like all products, a talk needs feedback too...</p>
            <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5 mt-4">
              <div>
                <div className="mt-1">
                  <label
                    htmlFor="speakerRating"
                    className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
                  >
                    Speaker
                  </label>
                  <Rating
                    id="speakerRating"
                    name="speakerRating"
                    onClick={speakerRatingChanged}
                    size={24}
                    ratingValue={speakerRating}
                  />
                </div>
                <div className="mt-4">
                  <label
                    htmlFor="contentRating"
                    className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
                  >
                    Content
                  </label>
                  <Rating
                    id="contentRating"
                    name="contentRating"
                    onClick={contentRatingChanged}
                    size={24}
                    ratingValue={contentRating}
                  />
                </div>
              </div>
            </div>
            <div className="mt-1 sm:mt-0 sm:col-span-2">
              <label htmlFor="comment" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                Comment
              </label>
              <div className="mt-1 sm:mt-0">
                <textarea
                  id="comment"
                  name="comment"
                  rows={3}
                  className="max-w-lg shadow-sm block w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border border-gray-300 rounded-md"
                  value={feedbackComment}
                  onChange={feedbackCommentChanged}
                />
                <p className="mt-2 text-sm text-gray-500">
                  Some helpful context around your ratings can really guide speakers on where to improve.
                </p>
                {feedbackSubmitted && (
                  <p className="mt-2 text-xs text-green-700 flex">
                    <CheckCircleIcon className="w-4 h-4 mr-1" />
                    Feedback auto-saved.
                  </p>
                )}
              </div>
            </div>
            <p className="mt-2 text-xs text-green-700 flex">
              <CheckCircleIcon className="w-4 h-4 mr-1" />
              Feedback auto-saved.
            </p>
          </Transition>
        )} */}
      <div className="bg-white p-4 rounded-lg mb-12">
        <div>
          {/* {session.data.Session_Groups && session.data.Session_Groups[0] && (
            <div className="mt-2 flex">
              <div className="flex items-center text-xs leading-5 text-gray-500">
                <svg
                  className="flex-shrink-0 mr-1 h-3 w-3 text-gray-500"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M9.243 3.03a1 1 0 01.727 1.213L9.53 6h2.94l.56-2.243a1 1 0 111.94.486L14.53 6H17a1 1 0 110 2h-2.97l-1 4H15a1 1 0 110 2h-2.47l-.56 2.242a1 1 0 11-1.94-.485L10.47 14H7.53l-.56 2.242a1 1 0 11-1.94-.485L5.47 14H3a1 1 0 110-2h2.97l1-4H5a1 1 0 110-2h2.47l.56-2.243a1 1 0 011.213-.727zM9.03 8l-1 4h2.938l1-4H9.031z"
                    clipRule="evenodd"
                  />
                </svg>
                <span>{session.data.Session_Groups[0].data.Job}</span>
              </div>
            </div>
          )} */}
          <div className="text-base text-gray-600 flex items-center content-center">
            {hasSessionType &&
              sessionTypes.map((type) => {
                const isActive = type.name === session.data.Session_Groups[0].data.Format
                return (
                  <Tooltip
                    key={type.name + session.id}
                    placement="top"
                    trigger={['hover']}
                    overlay={<span className="max-w-xs flex text-wrap">{type.description}</span>}
                  >
                    <div className="flex items-center text-md font-medium leading-5 text-gray-500 mb-4">
                      <span
                        className={`inline-flex items-center rounded-md  px-2 py-1 text-sm font-medium mr-1 ${
                          isActive
                            ? type.background + ' ' + type.text + ' ' + type.border
                            : 'bg-gray-50 text-gray-300 ring-gray-500/10 hidden xl:flex'
                        }`}
                      >
                        {isActive && (
                          <svg
                            className={`h-1.5 w-1.5 mr-1 ${type.ball}`}
                            viewBox="0 0 6 6"
                            aria-hidden="true"
                          >
                            <circle cx={3} cy={3} r={3} />
                          </svg>
                        )}
                        {type.name}
                        <InformationCircleIcon
                          className={`w-4 h-4 ml-1 ${isActive ? type.text : 'text-gray-300'}`}
                        />
                      </span>
                    </div>
                  </Tooltip>
                )
              })}
          </div>
        </div>
        <p className="text-2xl">{session.data.Talk_Title}</p>
        {sessionInfo.futureSession && (
          <>
            <p className="text-base text-gray-600">
              {new Date(
                getLocalDay(session.data.UTC_Start_Time, agendaDayTimezone || timezoneService.timezone),
              ).toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
              })}
              {', '}
              {getLocalTime(
                session.data.UTC_Start_Time,
                agendaDayTimezone || timezoneService.timezone,
              )} - {getLocalTime(session.data.UTC_End_Time, agendaDayTimezone || timezoneService.timezone)}
              <span className="text-sm text-gray-400">
                {' '}
                ({agendaDayTimezone || timezoneService.timezone})
              </span>
              {session.data.Stage && session.data.Stage[0] && ' - ' + session.data.Stage[0].data.Stage_Name}
            </p>

            {agendaDayTimezone && agendaDayTimezone !== timezoneService.timezone && (
              <p className="text-sm text-gray-400 italic pt-1">
                {new Date(
                  getLocalDay(session.data.UTC_Start_Time, timezoneService.timezone),
                ).toLocaleDateString('en-GB', {
                  day: '2-digit',
                  month: 'short',
                })}
                {', '}
                {getLocalTime(session.data.UTC_Start_Time, timezoneService.timezone)} -{' '}
                {getLocalTime(session.data.UTC_End_Time, timezoneService.timezone)}
                <span className="text-sm text-gray-400"> ({timezoneService.timezone})</span>
              </p>
            )}
          </>
        )}
        <div className="flex flex-wrap md:flex-nowrap justify-between pb-2">
          <div className="flex w-full md:w-auto">
            {session.data.Stream && session.data.Stream[0] && (
              <div className="mt-2 flex  mr-8">
                <div className="flex items-center text-sm leading-5 text-gray-500">
                  {/* <!-- Heroicon name: tag --> */}
                  <svg
                    className="flex-shrink-0 mr-2 h-5 w-5 text-gray-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
                    />
                  </svg>
                  <span>{session.data.Stream[0].data.Stream_Name}</span>
                </div>
              </div>
            )}
            {session.data.Conference && session.data.Conference[0] && (
              <div className="mt-2 flex">
                <div className="flex items-center text-sm leading-5 text-gray-500">
                  {/* <!-- Heroicon name: tag --> */}
                  <svg
                    className="flex-shrink-0 mr-2 h-5 w-5 text-gray-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                    />
                  </svg>
                  <span>
                    {session.data.Conference[0].data.Conference_Name} {session.data.Conference[0].data.Year}
                  </span>
                </div>
              </div>
            )}
          </div>
          <div className="flex pt-4 md:pt-0 w-full sm:w-auto justify-between">
            {/* {!sessionInfo.futureSession && (tickets.length > 0 || sessionInfo.publicSession) && !sessionInfo.feedbackEnded && */}
            {/* {!sessionInfo.futureSession && (tickets.length > 0 || sessionInfo.publicSession) && (!requiresRegister || (requiresRegister && isRegistered)) &&
                <div className='flex mr-3 text-gray-500 text-sm cursor-pointer items-center'>
                  <svg
                    onClick={() => showFeedbackModal(true)}
                    className='w-6 h-6 mr-5 hover:text-gray-900'
                    fill={userFeedback && userFeedback.liked ? 'green' : 'none'}
                    stroke={userFeedback && userFeedback.liked ? 'green' : 'currentColor'}
                    viewBox='0 0 24 24'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5' />
                  </svg>
                  <svg
                    onClick={() => showFeedbackModal(false)}
                    className='w-6 h-6 mr-1 hover:text-gray-900'
                    fill={userFeedback && !userFeedback.liked ? 'red' : 'none'}
                    stroke={userFeedback && !userFeedback.liked ? 'red' : 'currentColor'}
                    viewBox='0 0 24 24'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M10 14H5.236a2 2 0 01-1.789-2.894l3.5-7A2 2 0 018.736 3h4.018a2 2 0 01.485.06l3.76.94m-7 10v5a2 2 0 002 2h.096c.5 0 .905-.405.905-.904 0-.715.211-1.413.608-2.008L17 13V4m-7 10h2m5-10h2a2 2 0 012 2v6a2 2 0 01-2 2h-2.5' />
                  </svg>
                </div>} */}

            {!requiresRegister && (
              <div
                // only show for sessions that don't require Registration
                onClick={() => {
                  toggleFavourite(session.id, conferenceId, isFavourite)
                  setFavourite(!isFavourite)
                }}
                target="_blank"
                rel="noreferrer noopener"
                className="mr-3 text-gray-500 text-sm flex uppercase font-medium items-center hover:text-gray-900 cursor-pointer"
              >
                <svg
                  className={`w-6 h-6 mr-1 ${
                    isFavourite
                      ? 'text-yellow-500 fill-current stroke-current'
                      : 'text-gray-500 hover:text-gray-900'
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
                  />
                </svg>
              </div>
            )}
            <div className="flex mr-3 items-center relative">
              <Menu>
                {({ open }) => (
                  <>
                    <span className="rounded-md">
                      <Menu.Button
                        className="flex text-gray-500 font-medium text-sm uppercase items-center transition duration-50 ease-in-out hover:text-gray-900 focus:outline-none focus:ring-white"
                        id="share-button"
                      >
                        <svg
                          className="w-6 h-6 mr-1"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M15 8a3 3 0 10-2.977-2.63l-4.94 2.47a3 3 0 100 4.319l4.94 2.47a3 3 0 10.895-1.789l-4.94-2.47a3.027 3.027 0 000-.74l4.94-2.47C13.456 7.68 14.19 8 15 8z" />
                        </svg>
                        Share
                      </Menu.Button>
                    </span>

                    <Transition
                      show={open}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items
                        static
                        className="absolute flex justify-between align-center p-6 z-10 right-0 w-44 mt-5 origin-top-right bg-white border border-gray-800 divide-y divide-gray-100 rounded-md shadow-lg outline-none"
                      >
                        <div className="py-1">
                          <Menu.Item className="mr-2">
                            <LinkedinShareButton url={url}>
                              <LinkedinIcon
                                size={32}
                                title={
                                  'Check out this talk from UXDX: ' +
                                  getTalkTitle(session, session.data.Conference[0])
                                }
                                summary={session.data.Talk_Description}
                                source={url}
                              />
                            </LinkedinShareButton>
                          </Menu.Item>
                          <Menu.Item className="mr-2">
                            <TwitterShareButton url={url}>
                              <TwitterIcon
                                size={32}
                                title={
                                  'Check out this talk from UXDX: ' +
                                  getTalkTitle(session, session.data.Conference[0])
                                }
                                related="@uxdxconf"
                              />
                            </TwitterShareButton>
                          </Menu.Item>
                          <Menu.Item className="mr-2">
                            <RedditShareButton url={url}>
                              <RedditIcon
                                size={32}
                                title={
                                  'Check out this talk from UXDX: ' +
                                  getTalkTitle(session, session.data.Conference[0])
                                }
                              />
                            </RedditShareButton>
                          </Menu.Item>
                          <Menu.Item className="mr-2">
                            <EmailShareButton url={url}>
                              <EmailIcon
                                size={32}
                                subject={
                                  'Check out this talk from UXDX: ' +
                                  getTalkTitle(session, session.data.Conference[0])
                                }
                                body={session.data.Talk_Description + '/n/n You can watch it here: ' + url}
                              />
                            </EmailShareButton>
                          </Menu.Item>
                          <Menu.Item className="mr-2">
                            <WhatsappShareButton url={url}>
                              <WhatsappIcon
                                size={32}
                                title={
                                  'Check out this talk from UXDX: ' +
                                  getTalkTitle(session, session.data.Conference[0])
                                }
                              />
                            </WhatsappShareButton>
                          </Menu.Item>
                          <Menu.Item className="">
                            <FacebookShareButton url={url}>
                              <FacebookIcon
                                size={32}
                                quote={
                                  'Check out this talk from UXDX: ' +
                                  getTalkTitle(
                                    session,
                                    session.data.Conference[0] + '/n/n You can watch it here: ' + url,
                                  )
                                }
                              />
                            </FacebookShareButton>
                          </Menu.Item>
                        </div>
                      </Menu.Items>
                    </Transition>
                  </>
                )}
              </Menu>
            </div>
            {/* {isRegistered &&
              session.data.Location &&
              new Date(session.data.UTC_End_Time).getTime() > Date.now() && (
                <a
                  href={session.data.Location}
                  target="_blank"
                  rel="noreferrer noopener"
                  className="border border-gray-500 hover:bg-gray-100 rounded-md px-2 py-1"
                >
                  Join Zoom
                </a>
              )} */}
            {session.data.Slideshare &&
              !sessionInfo.futureSession &&
              (!requiresRegister || (requiresRegister && isRegistered)) && (
                <a
                  href={session.data.Slideshare}
                  target="_blank"
                  rel="noreferrer noopener"
                  className="mr-1 text-gray-500 text-sm flex uppercase font-medium items-center hover:text-gray-900"
                >
                  <svg
                    className="w-6 h-6 mr-1"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
                    <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
                  </svg>
                  Slides
                </a>
              )}

            {requiresRegister && sessionInfo.futureSession && (
              <>
                {(isForum || isActivity) && (
                  <InPersonActivityRegisterButton
                    sessionId={session.id}
                    conferenceId={conferenceId}
                    userRegistration={userRegistration}
                    sessionCapacity={session.data.Capacity}
                    recordId={session.recordId}
                    conferenceLocation={conferenceLocation}
                    sessionType={isForum ? 'Forum' : 'Activity'}
                    calendarId={session.data.Calendar_Id}
                    startTime={session.data.UTC_Start_Time}
                    sessionName={session.data.Talk_Title}
                    sessionSlug={session.data.Session_Slug}
                  />
                )}
                {isWorkshop && (
                  <SessionItemRegister
                    sessionCapacity={sessionCapacity}
                    sessionId={session.id}
                    conferenceId={conferenceId}
                    workshopDetails={getDetails()}
                    workshopTickets={workshopTickets}
                    userTickets={tickets}
                    userRegistration={userRegistration}
                    conferenceLocation={conferenceLocation}
                    recordId={session.recordId}
                    {...parseLimitsData()}
                    calendarId={session.data.Calendar_Id}
                    startTime={session.data.UTC_Start_Time}
                    sessionName={session.data.Talk_Title}
                    sessionSlug={session.data.Session_Slug}
                  />
                )}
              </>
            )}
          </div>
        </div>
        <div className={'text-base mt-3 markdown'} dangerouslySetInnerHTML={{ __html: description }} />
        {/* {session.data.Talk_Description && session.data.Talk_Description.length > 100 && (
            <a
              href='#'
              className='text-sm text-blue-500 cursor-pointer'
              onClick={(e) => {
                e.preventDefault()
                setDescriptionReadMore(!descriptionReadMore)
              }}
            >
              {descriptionReadMore ? 'Read Less <<' : 'Read More >>'}
            </a>
          )} */}

        {speakerCards}

        {/* <p className='text-2xl pt-8'>Your Notes</p>
          <textarea className='resize-y w-full mt-3 border border-dashed border-gray-600 p-2' placeholder='Save your notes here so you dont forget a thing' rows='5' name='notes' ref={notesRef} onChange={handleInputChange} />
          <p className='text-sm italic text-gray-500'>Note: you can access saved notes on your <Link to='/account/notes/' className='underline text-blue-500'>profile</Link></p> */}
        {/* <p className='text-2xl pt-12'>Talk Summary</p> */}

        {(isPublic || (loggedIn && verified && hasTicket)) && session.data.Talk_Transcript && (
          <>
            <button
              className="text-2xl mt-12 flex items-center"
              onClick={() => setShowTranscript(!showTranscript)}
            >
              Transcript
              {!showTranscript && (
                <svg
                  className="w-6 h-6 ml-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>Show the Transcript</title>
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              )}
              {showTranscript && (
                <svg
                  className="w-6 h-6 ml-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>Hide the Transcript</title>
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                </svg>
              )}
            </button>
            <div
              className={`${
                showTranscript ? 'block' : 'hidden'
              } text-xl mt-3 markdown leading-9 max-w-prose text-gray-700 font-sans markdown-large-p`}
              dangerouslySetInnerHTML={{
                __html: md.render(session.data.Talk_Transcript),
              }}
            />
          </>
        )}
      </div>
    </>
  )
}

SessionDetails.propTypes = {
  session: PropTypes.shape({
    id: PropTypes.string.isRequired,
    data: PropTypes.shape({
      Talk_Title: PropTypes.string.isRequired,
      Talk_Description: PropTypes.string,
      UTC_Start_Time: PropTypes.string.isRequired,
      UTC_End_Time: PropTypes.string.isRequired,
      Talk_Transcript: PropTypes.string,
      Slideshare: PropTypes.string,
      Location: PropTypes.string,
      Video: PropTypes.string,
      Public_Release_Date: PropTypes.array,
      Speakers: PropTypes.array,
      Capacity: PropTypes.number,
      Session_Exernal_Url: PropTypes.string,
      Session_Groups: PropTypes.arrayOf(
        PropTypes.shape({
          data: PropTypes.shape({
            Group: PropTypes.string.isRequired,
            Job: PropTypes.string.isRequired,
            Recordings_Available: PropTypes.bool,
            Requires_Register: PropTypes.bool,
          }),
        }),
      ),
      Stream: PropTypes.arrayOf(
        PropTypes.shape({
          data: PropTypes.shape({
            Stream_Name: PropTypes.string.isRequired,
          }),
        }),
      ),
      Stage: PropTypes.arrayOf(
        PropTypes.shape({
          data: PropTypes.shape({
            Stage_Name: PropTypes.string.isRequired,
          }),
        }),
      ),
      Conference: PropTypes.arrayOf(
        PropTypes.shape({
          data: PropTypes.shape({
            Conference_Id: PropTypes.string.isRequired,
            Conference_Name: PropTypes.string.isRequired,
            Year: PropTypes.string.isRequired,
            Location: PropTypes.string.isRequired,
          }),
        }),
      ),
    }),
  }),
  conferenceId: PropTypes.string.isRequired,
  toggleFavourite: PropTypes.func.isRequired,
  openFeedbackModal: PropTypes.func.isRequired,
  userUsedPlaces: PropTypes.number,
  isRegistered: PropTypes.bool,
  registrations: PropTypes.array,
}

export default withFeedbackModal(withToggleFavouriteSession(SessionDetails))
